// The offer's own $0 magnet sheet in the cart (issue #5218 item 9): "Free Photo
// Magnets (offer) — $0", so the parent sees the deal survive to checkout.
//
// Matched by NAME -- the same contract the server uses (Addon::FREE_MAGNETS_OFFER_NAME,
// seeded by migration and looked up by name because ids differ across restores).
// The client has no other signal: unit_price is $0 for the free sheet but the
// name is what tells it apart from a paid magnet sheet whose base package was
// free.
export const FREE_MAGNETS_OFFER_ADDON = 'Free Photo Magnets (offer)';

export const isFreeOfferAddon = (addon) => (addon?.name || '').trim() === FREE_MAGNETS_OFFER_ADDON;

// The cart line title for the free sheet's group.
export const freeOfferLineTitle = (addon) => `${(addon?.name || '').trim()} — $0`;

// Must this sheet survive a builder's blanket "destroy every sheet and replace
// with the new selection"?
//
// Yes for a sheet the OFFER put there: that wipe is meant to replace what the
// CUSTOMER chose, and nothing re-attaches the free magnet sheet afterwards --
// Cart#sync_free_magnets! needs a pose_id it can only get from the magnet page,
// and refresh_promo_offer! fires on order-package changes, not on addon-sheet
// destruction. So a customer who accepted their free magnets and then bought
// any add-on lost them silently, and production printed nothing.
//
// ONE implementation, because the wipe is written out in BOTH
// IndividualPrintsBuilder and AddonSheetBuilder and the rule has to hold in
// each. `editingSheetId` is the single-sheet edit case: there the builder is
// deliberately replacing one identified sheet, so nothing is protected.
export const survivesSheetReplacement = (sheet, { editingSheetId = null } = {}) => (
  !editingSheetId && isFreeOfferAddon(sheet?.addon)
);
